import leafio from '@montugroup/themes/brands/leafio';
import { BrandThemeProvider } from '@montugroup/themes/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { FC, PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ApiProvider } from './ApiProvider';
import { AuthProvider } from './AuthProvider';
import { FeatureFlagProvider } from './FeatureFlagProvider';
import { ReactQueryProvider } from './ReactQueryProvider';
import { SnowplowProvider } from './SnowplowProvider';

export const Providers: FC<PropsWithChildren> = ({ children }) => (
  <HelmetProvider>
    <ReactQueryProvider>
      <AuthProvider>
        <FeatureFlagProvider>
          <ApiProvider>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <SnowplowProvider>
                <BrandThemeProvider theme={leafio}>{children}</BrandThemeProvider>
              </SnowplowProvider>
            </LocalizationProvider>
          </ApiProvider>
        </FeatureFlagProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </ReactQueryProvider>
  </HelmetProvider>
);
